module.exports = __webpack_public_path__ + "img/cafe_de_la_p.f7149b73.png";